var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 499.19 259.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 213.28,
    y1: 548.64,
    x2: 634.82,
    y2: 388.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#27aae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2848a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ce1289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#ed1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbb040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 133.8,
    y1: 339.85,
    x2: 555.34,
    y2: 179.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 198.07,
    y1: 508.69,
    x2: 619.62,
    y2: 348.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 163.83,
    y1: 418.72,
    x2: 585.36,
    y2: 258.26,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M550.7,332.2A67.87,67.87,0,0,0,482.9,400v96.1a46.84,46.84,0,0,0,16,2.8V400a51.8,51.8,0,1,1,103.6,0v51.8a47,47,0,0,0,16,35.36V400h0a67.85,67.85,0,0,0-67.8-67.8Z",
    transform: "translate(-150.4 -239.68)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.33,317a82.56,82.56,0,0,1,60.28,26.11A108.4,108.4,0,0,1,319.29,330a98.46,98.46,0,0,0-70-29.14h0a98.29,98.29,0,0,0-51.83,14.71V287.18a47.58,47.58,0,0,0-16-35.66V351.4C196.51,329.9,221.34,317,249.33,317Z",
    transform: "translate(-150.4 -239.68)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M550.7,301.1A98.71,98.71,0,0,0,475.35,336,98.71,98.71,0,0,0,400,301.1c-54.51,0-98.86,44.26-98.9,99.23v.07h0a52,52,0,0,1-51.75,51.29h0a51.86,51.86,0,0,1,0-103.71h0a51.76,51.76,0,0,1,46.4,28.85,107,107,0,0,1,6.39-19.55,67.55,67.55,0,0,0-52.79-25.44h0a68,68,0,0,0,0,136h0A67.47,67.47,0,0,0,317.1,400.4h0c0-46.11,37.19-83.3,82.9-83.3a83.17,83.17,0,0,1,75.36,48.38A82.88,82.88,0,0,1,633.6,400v96.1a46.84,46.84,0,0,0,16,2.8V400A99,99,0,0,0,550.7,301.1ZM301.11,400.4h0C301.12,400.52,301.12,400.46,301.11,400.4Z",
    transform: "translate(-150.4 -239.68)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M400,332.2c-37.36,0-67.76,30.45-67.8,68.13v.07h0a83.38,83.38,0,0,1-3.66,24.15c-10.36,34.28-41.87,58.14-79.19,58.14a83,83,0,0,1-82.93-82.85V242.5a46.61,46.61,0,0,0-16-2.82V399.84a99.09,99.09,0,0,0,98.93,99h0a98.82,98.82,0,0,0,60.14-20.27h0c1.32-1,2.62-2.05,3.89-3.12l0,0a97.94,97.94,0,0,0,34.82-75,51.8,51.8,0,1,1,103.6-.4v51.8a47,47,0,0,0,16,35.36V400h0A67.85,67.85,0,0,0,400,332.2Zm-67.8,68.2h0C332.21,400.52,332.21,400.46,332.2,400.4Z",
    transform: "translate(-150.4 -239.68)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.46a6310a477149b42d3c59e25f1d96c3.svg";
export { ForwardRef as ReactComponent };